import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { MdAdd } from "react-icons/md";
import {
  deleteVehicleApi,
  getVehicleListApi,
} from "../../services/VehicleService";
import AddVehicleModal from "./AddVehicleModal";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { format } from "date-fns";
import { FiEdit2, FiTrash2, FiInfo } from "react-icons/fi";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
const Vehicle = () => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedData, setSelecetdData] = useState(null);

  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const handleToggleAddModal = () => {
    if (addModal) {
      setSelecetdData(null);
    }
    setAddModal(!addModal);
  };
  const handleToggleDelete = () => {
    if (deleteModal) {
      setSelecetdData(null);
    }
    setDeleteModal(!deleteModal);
  };
  const getData = () => {
    setLoading(true);
    getVehicleListApi(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [param]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
  const deleteVehicle = () => {
    setDeleteLoading(true);
    deleteVehicleApi(selectedData?.id || "")
      .then((res) => {
        toast.success("Delete Successfully");
        handleToggleDelete();
        getData();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };
  const handleAfterVehicleAdd = () => {
    handleToggleAddModal();
    getData();
  };

  const getValueByKey = (obj, key) => {
    return key
      .split(".")
      .reduce((acc, part) => (acc ? acc[part] : undefined), obj);
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <FaSort className="sort-icon neutral" />;
    }
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sort-icon active" />
    ) : (
      <FaSortDown className="sort-icon active" />
    );
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...data].sort((a, b) => {
      const valA = getValueByKey(a, key);
      const valB = getValueByKey(b, key);

      const numA = parseFloat(valA);
      const numB = parseFloat(valB);
      const dateA = Date.parse(valA);
      const dateB = Date.parse(valB);

      // Numeric sort if both are valid numbers
      if (!isNaN(numA) && !isNaN(numB)) {
        return direction === "asc" ? numA - numB : numB - numA;
      }

      // Date sort if both are valid dates
      if (!isNaN(dateA) && !isNaN(dateB)) {
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Fallback to string sort (letters, "inf", etc.)
      return direction === "asc"
        ? String(valA).localeCompare(String(valB), undefined, {
            sensitivity: "base",
          })
        : String(valB).localeCompare(String(valA), undefined, {
            sensitivity: "base",
          });
    });

    setData(sorted);
  };
  return (
    <div>
      <div className="card">
        <div className="p-4 d-flex justify-content-between flex-wrap gap-2">
          <div className="d-flex gap-1 flex-fill flex-md-grow-0">
            {/* <span className="btn btn-outline-light rounded-2 p-2">
              <FaArrowLeft className="text-dark" />
            </span> */}
            <div className="flex-fill">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
          </div>
          <div>
            <button
              className="btn btn-primary px-2"
              onClick={handleToggleAddModal}
              style={{ padding: "0.45rem 0" }}
            >
              <MdAdd size="20" />
              Add Vehicle
            </button>
          </div>
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center my-4 text-danger">{error}</div>
        ) : data && data?.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th
                    onClick={() => handleSort("vehicle_number")}
                    style={{ cursor: "pointer" }}
                  >
                    Vehicle Number{renderSortIcon("vehicle_number")}
                  </th>
                  <th
                    onClick={() => handleSort("vehicle_model.brand_name")}
                    style={{ cursor: "pointer" }}
                  >
                    Vehicle Brand{renderSortIcon("vehicle_model.brand_name")}
                  </th>
                  <th
                    onClick={() => handleSort("vehicle_type")}
                    style={{ cursor: "pointer" }}
                  >
                    Vehicle Type{renderSortIcon("vehicle_type")}
                  </th>
                  <th
                    onClick={() => handleSort("customer_name ")}
                    style={{ cursor: "pointer" }}
                  >
                    Customer{renderSortIcon("customer_name")}
                  </th>
                  <th
                    onClick={() => handleSort("total_services_completed")}
                    style={{ cursor: "pointer" }}
                  >
                    Total Service{renderSortIcon("total_services_completed")}
                  </th>
                  <th
                    onClick={() => handleSort("last_service_date")}
                    style={{ cursor: "pointer" }}
                  >
                    last Service{renderSortIcon("last_service_date")}
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={item.id}>
                    <td>{item?.vehicle_number || "-"}</td>
                    <td>
                      {item?.vehicle_model ? (
                        <div>
                          <span>{item?.vehicle_model?.brand_name || "-"}</span>
                          <span className="border-start ps-1 ms-1">
                            {item?.vehicle_model?.model_type || "-"}
                          </span>
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{item?.vehicle_type || "-"}</td>
                    <td>
                      <div className="d-flex flex-column">
                        <span
                          className="text-primary fw-medium"
                          style={{ fontSize: "0.88rem" }}
                        >
                          {item?.customer_name || "-"}
                        </span>
                        <span
                          className="text-dark fw-medium"
                          style={{ fontSize: "0.8rem" }}
                        >
                          {item?.customer_contact || "-"}
                        </span>
                      </div>
                    </td>
                    <td>{item?.total_services_completed || 0}</td>
                    <td>
                      {item?.last_service_date
                        ? format(item?.last_service_date, "dd MMM yyy")
                        : "-"}
                    </td>
                    <td>
                      <div className="d-flex gap-1 align-self-start">
                        <span
                          className="p-1 btn btn-outline-light ms-1"
                          onClick={() => {
                            setSelecetdData(item);
                            handleToggleAddModal();
                          }}
                        >
                          <FiEdit2 className="text-dark" size="12" />
                        </span>
                        <span
                          className="p-1 btn btn-outline-light ms-1"
                          onClick={() => {
                            setSelecetdData(item);
                            handleToggleDelete();
                          }}
                        >
                          <FiTrash2 className="text-dark" size="12" />
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">No data found</div>
        )}
        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>

      <AddVehicleModal
        data={selectedData}
        visible={addModal}
        onClose={handleToggleAddModal}
        onAfterSubmit={handleAfterVehicleAdd}
      />

      <Dialog
        maxWidth="xs"
        fullWidth
        open={deleteModal}
        onClose={handleToggleDelete}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>
                {selectedData?.vehicle_number}
              </strong>
              ? This action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleDelete}
            color="inherit"
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={deleteVehicle}
            disabled={deleteLoading}
          >
            {deleteLoading && <Spinner animation="border" size="sm" />}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Vehicle;
